import { call, put, select } from 'redux-saga/effects';
import { getByName } from '@bit/gerenciatd.adabyron.customizer';
import Sonda from '@bit/gerenciatd.utils.front-sonda';
import { actions } from '../reducers/filters';
import { normalizeFilters } from './normalizers/filters';

const contextStore = state => state.context.data;

/**
 * Realiza la llamada a customizer
 * para traer la información relativa a los filtros de la distributiva,
 * los normaliza y los sube a redux
 * @return {undefined}
 */
export function* getFilters() {
  try {
    const context = yield select(contextStore);
    const getByNameParams = {
      context,
      name: 'DISTRIBUTIVA-FUSION-FILTROS',
      originUrl: window.location.href,
    };
    const filters = yield call(getByName, getByNameParams);

    yield put(actions.setFilters(normalizeFilters(filters)));
  } catch (error) {
    const context = yield select(contextStore);
    const sonda = new Sonda({
      processName: 'getFilters',
      context,
      filePath: 'sagas/Filters',
    });
    sonda.errorMessage(error);
  }
}
